import axios from 'axios'
import swal from 'sweetalert2'

import { swalError } from '../../common/components/Swaler'

// if (!window.MYQLOCX_API) {
//     window.MYQLOCX_API = 'http://localhost:3001/api'
// }

const translateEntity = {
    subadmin: 'Åkeriadmin',
    c_terminal: 'Terminal',
    driver: 'Chaufför'
}

const collectionize = {
    c_terminal: 'c_terminals',
    driver: 'drivers',
    subadmin: 'subadmins'
}

export const updateDocument = (entityName, documentId, obj) => (dispatch) => {
    dispatch({ type: 'LOADING' })
    return axios
        .put(`${window.MYQLOCX_API}/subject/${window.localStorage.userType}/${collectionize[entityName]}/${documentId}`, { ...obj })
        .then(t => {
            swal.fire({
                html: `${translateEntity[entityName]} uppdaterad`,
                type: 'success',
                timer: 1500,
                showConfirmButton: false,
            })
            dispatch({ type: 'LOADING_FINISHED' })
            dispatch({ type: `UPDATE_${entityName.toUpperCase()}_FINISHED`, payload: t.data })
        })
        .catch((e) => {
            console.log(e)
            dispatch({ type: 'LOADING_FINISHED' })

            if (entityName === 'driver' && e.message === 'Användarinfo existerar redan!') e.message = 'Det går inte att uppdatera den här chauffören - skriv i chatten för assistans'

            swalError(e.message)
            throw e
        })
}

export const removeDocument = (entityName, id) => async (dispatch) => {
    dispatch({ type: 'LOADING' })
    return axios.delete(`${window.MYQLOCX_API}/subject/${window.localStorage.userType}/${collectionize[entityName]}/${id}`).then((t) => {
        swal.fire({
            html: `${translateEntity[entityName]} raderad`,
            type: 'success',
            timer: 1500,
            showConfirmButton: false,
        })
        dispatch({ type: 'LOADING_FINISHED' })
        dispatch({ type: `REMOVE_${entityName.toUpperCase()}_FINISHED`, payload: id })
    })
}

export function createDocument(entityName, obj) {
    return (dispatch) => {
        dispatch({ type: 'LOADING' })
        return axios
            .post(`${window.MYQLOCX_API}/subject/${window.localStorage.userType}/${collectionize[entityName]}`, { ...obj })
            .then((res) => {
                dispatch({ type: 'LOADING_FINISHED' })
                dispatch({
                    type: `CREATING_${entityName.toUpperCase()}_FINISHED`,
                    payload: res.data,
                })
                return res
            })
            .catch((err) => {
                dispatch({ type: 'LOADING_FINISHED' })
                return err
            })
    }
}

export const updateDeliveryStatus = (obj) => async (dispatch) => {
    return axios.put(`${window.MYQLOCX_API}/subject/${window.localStorage.userType}/deliveries/status`, obj).then(t => {
        console.log(t.data)
        dispatch({
            type: 'DELIVERY_STATUS_UPDATED',
            payload: t.data
        })

        swal.fire({
            html: `Status uppdaterad`,
            type: 'success',
            timer: 1500,
            showConfirmButton: false,
        })
    })
}